module.exports = __webpack_public_path__ + "static/media/icon_expand_black.e3f6d9ba.png";